import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { i18n } from '@/i18n'
import App from '@/App.vue'
import router from '@/router'

// Import CSS
import './application.css'
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)

app.mount('#app')

// Set initial HTML lang attribute
document.documentElement.lang = i18n.global.locale.value
